import { render, staticRenderFns } from "./UsuarioFornecedorCadastroDialog.vue?vue&type=template&id=220d3588"
import script from "./UsuarioFornecedorCadastroDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorCadastroDialog.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorCadastroDialog.vue?vue&type=style&index=0&id=220d3588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports